<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-right mt-0 mt-md-4 mt-lg-0">
            <router-link
              :to="`/admin/batches/${$route.params.idBatch}/acompanhamento`"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar para o painel de
              acompanhamento do batch</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div
          class="col-lg-4 order-lg-1 order-md-0 vld-parent"
          ref="card_startup"
        >
          <startup-batch-info
            v-if="batch && startup"
            :startup="startup"
            :batch="batch"
            basePage="admin"
            endPage="acompanhamento"
          />
        </div>
        <div class="col-lg-8 mt-lg-0 mt-3 vld-parent" ref="batch_info">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Cards personalizados
                    <span class="text-warning">{{
                      startup.name || "..."
                    }}</span>
                    <base-button
                      size="sm"
                      type="primary"
                      class="float-right"
                      :custom="true"
                      @click="handleNewCard()"
                      ><i class="fas fa-plus mr-1"></i> Novo card
                    </base-button>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-12 vld-parent" ref="list_cards">
              <div v-if="empty">
                <div class="row">
                  <div class="col-12 text-center">
                    <badge type="warning" class="bg-white">
                      Nenhum card personalizado foi vinculado à startup até o
                      momento
                    </badge>
                  </div>
                </div>
              </div>
              <div v-else>
                <CustomCardList
                  :data="cards"
                  v-if="cards.length"
                  :showEditLink="true"
                />
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StartupBatchInfo from "@/components/StartupDashboard/StartupBatchInfo";
import CustomCardList from "@/components/CustomCardList";
import api from "@/services/api";

export default {
  name: "admin_startup_metrics",
  components: {
    StartupBatchInfo,
    CustomCardList,
  },
  data() {
    return {
      batch: "",
      startup: "",
      cards: [],
      empty: "",
    };
  },
  async mounted() {
    const loaderStartup = this.$loading.show({
      container: this.$refs.card_startup,
      width: 140,
      height: 140,
      opacity: 0,
    });
    const loaderBatchInfo = this.$loading.show({
      container: this.$refs.batch_info,
      width: 140,
      height: 140,
      opacity: 0,
    });
    try {
      await this.loadBatch();
      await this.loadStartup();
      await this.loadCards();
      loaderStartup.hide();
      loaderBatchInfo.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao carregar informações");
    }
  },
  methods: {
    async loadBatch() {
      try {
        const { data: batch } = await api.get(
          `/batches/${this.$route.params.idBatch}`
        );
        if (!batch) throw new Error("Batch not found");
        this.batch = batch;
      } catch (e) {
        this.$toasted.error("Error ao carregar informações do batch");
        this.$router.push("/admin/batches");
      }
    },
    async loadStartup() {
      try {
        const { data: startup } = await api.get(
          `/adm/startups/${this.$route.params.idStartup}`
        );
        if (!startup) throw new Error("Startup not found");
        this.startup = startup;
        const defaultLogoPath = "/img/pages/default_logo.png";
        if (!this.startup.logo) this.startup.logo = { url: defaultLogoPath };
      } catch (e) {
        this.$toasted.error("Error ao carregar as informações da startup");
        this.$router.push(
          `/admin/batches/${this.$route.params.idBatch}/acompanhamento`
        );
      }
    },
    async loadCards() {
      const loaderCards = this.$loading.show({
        container: this.$refs.list_cards,
        width: 140,
        height: 140,
      });
      try {
        const { data: cards } = await api.get(
          `/startup-cards/batches/${this.$route.params.idBatch}/startups/${this.$route.params.idStartup}`
        );
        if (!cards.length) this.empty = true;
        else this.cards = cards;
        loaderCards.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao carregar os cards");
      }
    },
    handleNewCard() {
      this.$router.push(
        `/admin/batches/${this.$route.params.idBatch}/acompanhamento/startups/${this.$route.params.idStartup}/cards/novo`
      );
    },
  },
};
</script>
